import { Typography, IconButton, Tooltip } from "@material-ui/core";
import { green, pink } from "@material-ui/core/colors";
import LaunchIcon from "@material-ui/icons/Launch";
import { InfoWindow, Marker, MarkerClusterer } from "@react-google-maps/api";
import React, { useCallback } from "react";
import { isMobile, isBrowser } from "react-device-detect";
import { useActions, useValues } from "kea";
import { mdiEngine } from "@mdi/js";
import Icon from "@mdi/react";
import CloseIcon from "@material-ui/icons/Close";

import {
	maplogic,
	preferenceslogic,
	replaylogic,
	infowindowlogic,
} from "src/store/global";
import vehiclelogic from "src/store/vehicle";

import NewCarMarkerIgnitionON from "../../../resources/tracker-icons/sedan-white-active.png";
import NewCarMarkerIgnitionOFF from "../../../resources/tracker-icons/sedan-white-inactive.png";
import TrailMarkerGreen from "../../../resources/trail/green_16.png";
import TrailMarkerRed from "../../../resources/trail/red_16.png";

function DrawVehicle() {
	const { replay } = useValues(preferenceslogic);

	const {
		fetchUpdatedPosition,
		setHistory,
		setReplay,
		setNearbyAssets,
	} = useActions(vehiclelogic);

	const { vehicles, updatePosition } = useValues(maplogic);
	const { removeOne } = useActions(maplogic);

	const { vehicle, index } = useValues(replaylogic);
	const { setIndex } = useActions(replaylogic);

	const { set: setInfoWindowVehicle } = useActions(infowindowlogic);

	React.useEffect(() => {
		let lastts = new Date();
		const limit = 50;
		const update = async () => {
			if (!replay.show) {
				let batch;
				let toupdate = vehicles;
				// console.log('New Batch')
				// let accumulatedVehicles = [];
				if (vehicles.length > 0 && updatePosition) {
					while (toupdate.length) {
						batch = toupdate.slice(0, limit);
						toupdate = toupdate.slice(limit);
						// console.log('Batch of', batch.length, 'vehicles')
						await fetchUpdatedPosition(batch, lastts);
						// console.log('Updated', updated.payload.vehicles)
						// accumulatedVehicles = accumulatedVehicles.concat(updated.payload.vehicles);
					}
					// console.log('Total updated vehicles:', accumulatedVehicles)
					lastts = new Date();
				}
			}
		};
		const interval = setInterval(update, 5000);
		return () => clearInterval(interval);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [vehicles, updatePosition]);

	// const handleClickOptions = tracker => () => {
	// 	setInfoWindowVehicle(tracker);
	// 	setHistory([])
	// 	setReplay([])
	// 	setNearbyAssets([])
	// }

	const handleClickOptions = useCallback(
		(tracker) => () => {
			setInfoWindowVehicle(tracker);
			setHistory([]);
			setReplay([]);
			setNearbyAssets([]);
		},
		[setInfoWindowVehicle, setHistory, setReplay, setNearbyAssets],
	);

	const handleMarkerLoad = (marker) => {
		console.log("Marker loaded:", marker);
	};

	const handleHide = (vehicle) => () => {
		removeOne(vehicle);
	};

	//width & height of marker icon
	const markerIconSize = 64;

	return (
		<>
			{replay.show ? (
				<>
					{// assign icon type for use in marker
					vehicle.status.map((item, i) => {
						let icon =
							i === index
								? item.io.ignition
									? NewCarMarkerIgnitionON
									: NewCarMarkerIgnitionOFF
								: item.io.ignition
								? TrailMarkerGreen
								: TrailMarkerRed;
						const icon_size = i === index ? 72 : 14;
						return (
							<Marker
								icon={{
									url: icon,
									scaledSize: new window.google.maps.Size(icon_size, icon_size),
									origin: new window.google.maps.Point(0, 0),
									anchor: new window.google.maps.Point(
										icon_size / 2,
										icon_size / 2,
									),
								}}
								position={{
									lat: item.latitude,
									lng: item.longitude,
								}}
								onClick={() => setIndex(i)}
							></Marker>
						);
					})}
				</>
			) : (
				// The previous locations
				<MarkerClusterer
					options={{
						imagePath:
							"https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
					}}
				>
					{(clusterer) => {
						let res = [];
						// console.log("Rendering clusterer")
						for (let index = 0; index < vehicles.length; index++) {
							const item = vehicles[index];
							if (!item.tracker || item.tracker.status.length === 0) {
								continue;
							}
							let initial_status = item.tracker.status[0];
							res.push(
								<Marker
									icon={{
										url: item?.image?.image || NewCarMarkerIgnitionON,
										scaledSize: new window.google.maps.Size(
											markerIconSize,
											markerIconSize,
										),
										origin: new window.google.maps.Point(0, 0),
										anchor: new window.google.maps.Point(36, 36),
									}}
									position={{
										lat: initial_status.latitude,
										lng: initial_status.longitude,
									}}
									clusterer={clusterer}
									onLoad={handleMarkerLoad}
								>
									<InfoWindow
										zIndex={9999}
										options={{
											disableAutoPan: vehicles.length > 1,
										}}
									>
										<>
											{isBrowser && (
												<div
													style={{
														display: "flex",
														flexGrow: 1,
														alignItems: "center",
													}}
												>
													<IconButton size="small">
														<Icon
															path={mdiEngine}
															size={1}
															style={
																item.tracker.status[0].io.ignition
																	? { color: green[500] }
																	: { color: pink["A400"] }
															}
														/>
													</IconButton>
													<Typography style={{ marginRight: "36px" }}>
														{item.name}
													</Typography>
													<Tooltip title="Open the Vehicle Info Panel">
														<IconButton
															aria-label="more"
															aria-controls="long-menu"
															aria-haspopup="true"
															onClick={handleClickOptions(item)}
															size="small"
														>
															<Typography>Open</Typography>
															<LaunchIcon />
														</IconButton>
													</Tooltip>
													<Tooltip title="Hide this Vehicle">
														<IconButton
															aria-label="more"
															aria-controls="long-menu"
															aria-haspopup="true"
															onClick={handleHide(item)}
															size="small"
														>
															<CloseIcon />
														</IconButton>
													</Tooltip>
												</div>
											)}
											{isMobile && (
												<div
													style={{
														display: "flex",
														flexGrow: 1,
														alignItems: "center",
													}}
												>
													<IconButton
														size="small"
														style={{ paddingRight: "10px" }}
													>
														<Icon
															path={mdiEngine}
															size={1}
															style={
																item.tracker.status[0].io.ignition
																	? { color: green[500] }
																	: { color: pink["A400"] }
															}
														/>
													</IconButton>
													<Typography>
														{item.name} ({item.tracker.status[0].speed} Kmph)
													</Typography>
												</div>
											)}
										</>
									</InfoWindow>
								</Marker>,
							);
						}
						return res;
					}}
				</MarkerClusterer>
			)}
		</>
	);
}

export default DrawVehicle;
